import { Env } from '../../env';
import { ApiClient } from '../../http/api_client';
import { TonerJsEnv } from '../../models/toner/toner_js_env';

export class TonerRepository {
  private async getToners(
    searchType: string,
    printerMaker: string,
    printerType: number | null,
  ): Promise<TonerJsEnv> {
    const result = await ApiClient.get(Env.SETTING.userPublicApi.urlBase + 'api/attract/search/toners/',
      {
        params: {
          searchType,
          printerMaker,
          printerType: printerType || ''
        }
      });

    return new TonerJsEnv(
      result.printerMakers,
      result.printerTypes,
      result.printerModels,
      '',
      null,
      ''
    )
  }

  getPrinterMakers(searchType: string): Promise<TonerJsEnv> {
    return this.getToners(searchType, '', null);
  }

  getPrinterTypes(
    searchType: string,
    printerMaker: string,
  ): Promise<TonerJsEnv> {
    return this.getToners(searchType, printerMaker, null);
  }

  getPrinterModels(
    searchType: string,
    printerMaker: string,
    printerType: number | null,
  ): Promise<TonerJsEnv> {
    return this.getToners(searchType, printerMaker, printerType);
  }
}